export default {"src":"https://web.cdn.greenlight.com/2.1280.0/_next/static/media/link-icon.f6158122.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};